import { bulkUpdatePricesByCoefficient, getBulkPreview, getProductById, updateProductAvgCost } from '../../catalog/infra-api'
import { lookupProductByBarcode, searchProducts } from '../../catalog/infra-api';
import {
  adjustStock,
  applyPhysicalCountMixedBatch,
  bulkUpdateQuantitiesByCoefficient,
  getLastStockMovementUnitCost,
  getStockByBranch,
  getStockByProductAndBranch,
  getStockMovementHistory,
  getStockMovementHistoryForExport,
  isInventoriableProduct,
  listVariantStockCells,
  receiveStock,
  receiveTransfer,
  rejectTransfer,
  transferStock,
} from '../stock/public-api';
import type { InventoryOperationsPort } from './inventoryOperationsPort';

const ALL_STOCK_PAGE_SIZE = 200;

async function getAllStockForBranch(branchId: string) {
  const all = [];
  let offset = 0;
  for (;;) {
    // Solo filas de stock reales: el conteo físico usa stockId para decidir
    // adjust vs receive, y el bulk opera sobre cantidades existentes.
    const batch = await getStockByBranch(branchId, { limit: ALL_STOCK_PAGE_SIZE, offset, includeUnstocked: false });
    all.push(...batch);
    if (batch.length < ALL_STOCK_PAGE_SIZE) break;
    offset += batch.length;
  }
  return all;
}

async function searchInventoriableProducts(opts: { limit: number; offset: number }) {
  const batch = await searchProducts({ search: '', limit: opts.limit, offset: opts.offset, inventoryPhysicalOnly: true });
  return batch.filter((product) => isInventoriableProduct(product));
}

export const inventoryOperationsPortLive: InventoryOperationsPort = {
  getStockPage: (branchId, opts) => getStockByBranch(branchId, opts),
  getAllStockForBranch,
  listVariantStockCells: (branchId, productId) => listVariantStockCells(branchId, productId),
  searchInventoriableProducts,
  getStockByProductAndBranch: (branchId, productId) => getStockByProductAndBranch(branchId, productId),
  getProductById: (productId) => getProductById(productId),
  lookupBarcode: (code) => lookupProductByBarcode({ code, allowRemoteLookup: true }),
  getBulkPreview: (query) => getBulkPreview(query),
  getLastUnitCost: (productId, branchId) => getLastStockMovementUnitCost(productId, branchId),
  getMovementHistory: (stock, limit, offset, filters, remoteOptions) =>
    getStockMovementHistory(stock, limit, offset, filters, remoteOptions),
  getMovementHistoryForExport: (stock, filters, limit, remoteOptions) =>
    getStockMovementHistoryForExport(stock, filters, limit, remoteOptions),
  // El port declara Promise<void>: descartar el resultado pero propagar errores.
  receiveStock: async (input) => { await receiveStock(input); },
  adjustStock: (input) => adjustStock(input),
  correctStockAvgCost: (input) =>
    updateProductAvgCost(input.productId, input.avgCost, { performedByUserId: input.performedByUserId }),
  transferStock: async (input, opts) => { await transferStock(input, opts); },
  receiveTransfer: (transferId, meta) => receiveTransfer(transferId, meta),
  rejectTransfer: (transferId, meta) => rejectTransfer(transferId, meta),
  applyPhysicalCountMixedBatch: (branchId, items, meta) => applyPhysicalCountMixedBatch(branchId, items, meta),
  bulkUpdatePrices: (productIds, coefficient, meta) =>
    bulkUpdatePricesByCoefficient(productIds, coefficient, meta),
  bulkUpdateQuantities: (branchId, productIds, coefficient, meta) =>
    bulkUpdateQuantitiesByCoefficient(branchId, productIds, coefficient, meta),
};
